import { useCallback, useContext } from 'react';
import MaiaTranslationContext from './MaiaTranslationContext';

function interpolate(template, values) {
  if (!values || typeof template !== 'string') {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : `{${key}}`
  );
}

/**
 * @typedef {(
 *   id: string,
 *   fallback: string,
 *   values?: Record<string, string | number>
 * ) => string} MaiaTranslate
 */

/**
 * @returns {MaiaTranslate}
 */
export function useMaiaT() {
  const { messages } = useContext(MaiaTranslationContext);

  return useCallback(
    /** @type {MaiaTranslate} */
    (id, fallback, values) => {
      const raw = messages[id];
      const resolved = raw !== undefined && raw !== '' ? raw : fallback;
      return interpolate(resolved, values);
    },
    [messages]
  );
}
